import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Tab, Tabs, Form } from "react-bootstrap";
import {
  LegendFieldComponent,
  LegendTextareaComponent,
  IconFieldComponent,
} from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import "./AccountStyle.css";
import Swal from "sweetalert2";


export default function MyAccountPage() {
  const { t } = useContext(TranslatorContext);
  const AuthToken = localStorage.getItem("AuthUser");


let storedData = JSON.parse(localStorage.getItem("user"));

  console.log("Logged in user data", storedData);
  console.log("Logged in user-id", storedData.id);

  const [formstate, setFormState] = useState({
    fullname: storedData?.name || "",
    username: storedData?.email || "",
    phoneNumber: storedData?.phone || "",
    avatarPreview: storedData?.avatar
      ? `${process.env.REACT_APP_IMG_URL}${storedData.avatar}`
      : "/images/pattern.webp",
    avatar: null,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  	// const errorMessages = () => {
  
	// 	Swal.fire({
	// 		title: "Error!",
	// 		text: "Please fill in the required fields",
	// 		icon: "error",
	// 		confirmButtonText: "Ok",
	// 	});
	// };
  

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      const previewUrl = file ? URL.createObjectURL(file) : null;

      setFormState((prevState) => ({
        ...prevState,
        avatar: file,
        avatarPreview: previewUrl,
      }));
    } else {
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

const handleChangePassword = async () => {
  if (formstate.newPassword !== formstate.confirmPassword) {
    Swal.fire("Error", "New and confirm passwords are not the same.", "error");
    return;
  }

  try {
    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/update-password`,
      {
        current_password: formstate.currentPassword,
        new_password: formstate.newPassword,
      }
    );

    if (response.data.success) {
      const updatedUser = response.data.user;

      if (updatedUser) {
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }

      Swal.fire(
        "Success!",
        response.data.message || "Password updated successfully.",
        "success"
      );

      setFormState((prev) => ({
        ...prev,
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      }));
    } else {
      Swal.fire(
        "Error!",
        response.data.message || "Password update failed.",
        "error"
      );
    }
  } catch (err) {
    console.error("Error saving user:", err.response?.data || err);
    Swal.fire(
      "Error!",
      err.response?.data?.message || "Something went wrong while updating password.",
      "error"
    );
  }
};




 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const apiFormData = new FormData();
    apiFormData.append("name", formstate.fullname);
    apiFormData.append("email", formstate.username);
    apiFormData.append("phone", formstate.phoneNumber);

    if (formstate.currentPassword) {
      apiFormData.append("password", formstate.currentPassword);
    }
    if (formstate.avatar instanceof File) {
      apiFormData.append("avatar", formstate.avatar);
    }

    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/update-profile`,
      apiFormData
    );

    if (response.data.user) {
      localStorage.setItem("user", JSON.stringify(response.data.user));

      Swal.fire(
        "Success!",
        response.data.message || "Profile updated successfully.",
        "success"
      );
    } else {
      Swal.fire(
        "Error!",
        response.data.message || "Profile update failed.",
        "error"
      );
    }

    setFormState((prev) => ({
      ...prev,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    }));
  } catch (err) {
    console.error("Error saving user:", err.response?.data || err);
    Swal.fire(
      "Error!",
      err.response?.data?.message || "Something went wrong while updating profile.",
      "error"
    );
  }
};


  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{t("my_account")}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link text-success">
                    {t("home")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link text-success">
                    {t("users")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{t("my_account")}</li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xl={12}>
          <div className="mc-card">
            <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
              {/* Profile Tab */}
              <Tab
                eventKey="profile"
                title={t("edit_profile")}
                className="acc-tab mc-tabpane profile"
              >
                <div className="mc-tab-card">
                  <h6 className="mc-tab-card-title">
                    {t("User Information")}
                  </h6>
                  <Row>
                    <Col xl={4}>
                      <div className="mc-user-avatar-upload">
                        <div className="mc-user-avatar">
                          <img
                            src={
                              formstate.avatarPreview || "/images/pattern.webp"
                            }
                            alt="avatar"
                          />
                        </div>
                        <FileUploadComponent
                          icon="cloud_upload"
                          name="avatar"
                          value={formstate.avatar}
                          text={t("upload")}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col xl={8}>
                      <Row>
                        <Col xl={6}>
                          <LegendFieldComponent
                            type="text"
                            name="fullname"
                            title={t("fullname")}
                            value={formstate.fullname}
                            className="mb-4"
                            onChange={handleChange}
                          />
                        </Col>
                        <Col xl={6}>
                          <LegendFieldComponent
                            type="text"
                            name="username"
                            title={t("username")}
                            value={formstate.username}
                            className="mb-4"
                            onChange={handleChange}
                          />
                        </Col>
                        <Col xl={6}>
                          <LegendFieldComponent
                            title={t("phoneNumber")}
                            name="phoneNumber"
                            type="number"
                            value={formstate.phoneNumber}
                            className="mb-4"
                            onChange={handleChange}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>

                <ButtonComponent
                  className="acc-btn mc-btn "
                  icon="verified"
                  text={t("save_changes")}
                  onClick={handleSubmit}
                />
              </Tab>

              <Tab
                eventKey="password"
                title={t("change_password")}
                className="mc-tabpane password"
              >
                <div className="mc-tab-card">
                  <h6 className="mc-tab-card-title">{t("change_password")}</h6>
                  <Row>
                    <Col xs={12} md={12}>
                      <IconFieldComponent
                        icon="lock"
                        type="password"
                        name="currentPassword"
                        placeholder={t("current_password")}
                        value={formstate.currentPassword}
                        classes="w-100 h-lg mb-4"
                        passwordVisible
                        onChange={handleChange}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <IconFieldComponent
                        icon="add_moderator"
                        type="password"
                        name="newPassword"
                        placeholder={t("new_password")}
                        value={formstate.newPassword}
                        classes="w-100 h-lg mb-4"
                        passwordVisible
                        onChange={handleChange}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <IconFieldComponent
                        icon="verified_user"
                        type="password"
                        name="confirmPassword"
                        placeholder={t("confirm_password")}
                        value={formstate.confirmPassword}
                        classes="w-100 h-lg mb-4"
                        passwordVisible
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                </div>

				
                <ButtonComponent
                  className=" acc-btn mc-btn "
                  icon="verified"
                  text={t("save_changes")}
                  onClick={handleChangePassword}
                />
              </Tab>
            </Tabs>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}
